import axios from "axios";

export const tracking = (id = 0, dynId = 0, event = 'NEVS23') => {
   axios.post(`https://youngstartup.io/api/anlytcs/click/${id}?dyn_id=${dynId}&event=${event}`)
}
